import { render, staticRenderFns } from "./uploadProducts.vue?vue&type=template&id=274d086d&scoped=true"
import script from "./uploadProducts.vue?vue&type=script&lang=js"
export * from "./uploadProducts.vue?vue&type=script&lang=js"
import style0 from "./uploadProducts.vue?vue&type=style&index=0&id=274d086d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274d086d",
  null
  
)

export default component.exports